export default "__VITE_ASSET__DFvA9Xro__"